export default "__VITE_ASSET__7e046626__"